import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';

const apiUrl = `${API_URL}/program`;

export const ACTION_TYPES = {
  FETCH_PROGRAMHISTORY_LIST: 'PROGRAMHISTORY/FETCH_PROGRAMHISTORY_LIST',
  FETCH_PROGRAMHISTORY: 'PROGRAMHISTORY/FETCH_PROGRAMHISTORY',
  CREATE_PROGRAMHISTORY: 'PROGRAMHISTORY/CREATE_PROGRAMHISTORY',
  UPDATE_PROGRAMHISTORY: 'PROGRAMHISTORY/UPDATE_PROGRAMHISTORY',
  DELETE_PROGRAMHISTORY: 'PROGRAMHISTORY/DELETE_PROGRAMHISTORY',
  RESET: 'PROGRAMHISTORY/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  entities: [],
  entity: {}, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const programhistoryReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PROGRAMHISTORY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PROGRAMHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PROGRAMHISTORY):
    case REQUEST(ACTION_TYPES.UPDATE_PROGRAMHISTORY):
    case REQUEST(ACTION_TYPES.DELETE_PROGRAMHISTORY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PROGRAMHISTORY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PROGRAMHISTORY):
    case FAILURE(ACTION_TYPES.CREATE_PROGRAMHISTORY):
    case FAILURE(ACTION_TYPES.UPDATE_PROGRAMHISTORY):
    case FAILURE(ACTION_TYPES.DELETE_PROGRAMHISTORY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROGRAMHISTORY_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PROGRAMHISTORY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PROGRAMHISTORY):
    case SUCCESS(ACTION_TYPES.UPDATE_PROGRAMHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PROGRAMHISTORY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default programhistoryReducer;

// ACTIONS

export const getEntitiesByProgramId = (id, page, size, sort) => ({
  type: ACTION_TYPES.FETCH_PROGRAMHISTORY_LIST,
  payload: axios.get(`${apiUrl}/${id}`, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
